export class AppPageHeader extends HTMLElement {
  static get observedAttributes() {
    return ["title", "subtitle", "breadcrumb"];
  }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const title     = this.getAttribute("title")     || "";
    const subtitle  = this.getAttribute("subtitle")  || "";
    const breadcrumb = this.getAttribute("breadcrumb") || "";

    const actionsSlot = this.querySelector("[slot='actions']")?.innerHTML || "";

    // Breadcrumb: "INSPECT IA / DASHBOARD" → tokens separados por ›
    let breadcrumbHtml = "";
    if (breadcrumb) {
      const parts = breadcrumb.split("/").map(p => p.trim());
      const items = parts.map((part, i) =>
        i < parts.length - 1
          ? `<span>${part}</span><span class="breadcrumb-sep" aria-hidden="true">›</span>`
          : `<span style="color: var(--color-text-secondary);">${part}</span>`
      ).join("");
      breadcrumbHtml = `<nav class="breadcrumb" aria-label="Localização">${items}</nav>`;
    }

    this.innerHTML = `
      <div class="page-header">
        <div class="page-header-main">
          ${breadcrumbHtml}
          <h1 class="text-page-title">${title}</h1>
          ${subtitle ? `<p class="text-body-small" style="margin: 0; margin-top: 2px;">${subtitle}</p>` : ""}
        </div>
        ${actionsSlot ? `<div class="page-header-actions">${actionsSlot}</div>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-page-header")) {
  customElements.define("app-page-header", AppPageHeader);
}

export class AppSectionHeader extends HTMLElement {
  static get observedAttributes() {
    return ["title", "subtitle"];
  }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const title    = this.getAttribute("title")    || "";
    const subtitle = this.getAttribute("subtitle") || "";
    const actionsSlot = this.querySelector("[slot='actions']")?.innerHTML || "";

    this.innerHTML = `
      <div class="section-header">
        <div>
          <h2 class="text-section-title">${title}</h2>
          ${subtitle ? `<p class="text-caption" style="margin: 2px 0 0 0;">${subtitle}</p>` : ""}
        </div>
        ${actionsSlot ? `<div class="page-header-actions">${actionsSlot}</div>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-section-header")) {
  customElements.define("app-section-header", AppSectionHeader);
}
